export const TOAST_TYPE = {
  BOOKING: "booking",
  PREDEFINED: "predefined"
};
